<div [class]="config.parentClass">
    <ng-container *ngFor="let item of config.list; let i = index">
      <ng-template
        *ngTemplateOutlet="
          listItem;
          context: { item: item, index: i}
        "
    ></ng-template>
    </ng-container>
  </div>

  